// node_modules
import { FC, useContext, useEffect } from "react";
// Constants
import { CasePhaseConstants, LoggingConstants } from "Constants";
// Contexts
import { CaseContext } from "Stores";
// Components
import { TiOverview } from "./TiOverview";
import { ToOverview } from "./ToOverview";
import { PendoHelperSingleton } from "Helpers";

export const DeliveryOverview: FC = () => {
    // Shared states
    const { caseState } = useContext(CaseContext);

    useEffect(() => {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}CaseDeliveryOverview`, {
            caseId: caseState.selectedCaseId,
            phase: caseState.casePhase.toLocaleLowerCase()
        });
    }, [caseState.casePhase, caseState.selectedCaseId]);

    if(caseState.casePhase.toLocaleLowerCase() === CasePhaseConstants.PHASE_1.toLowerCase()) {
        return (<ToOverview />);
    } else {
        return (<TiOverview />);
    }
};